import React from "react";
import styles from "./AlertTag.module.css";

interface AlertTagProps {
  text: string;
}

const AlertTag: React.FC<AlertTagProps> = ({ text }) => {
  return <div className={styles.tag}>{text}</div>;
};

export default AlertTag;
